
export default {
  name: 'NavBarButtonLink',
  props: {
    link: {
      type: Object,
      required: true,
    },
    isOpened: {
      type: Boolean,
      default: false,
    },
    isChildLinksOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      if (!this.link.childLinks) {
        this.$emit('closeNavBar')
      } else {
        this.$emit('toggleChildLinks')
      }
      this.link.redirectToQuestions && this.redirectToQuestions()
    },
    async redirectToQuestions() {
      const redirectUrl = await this.$axios
        .post('api/auth/authorize-questions')
        .then((res) => res.data.redirect_url)
      window.location.replace(process.env.QUESTIONS_URL + redirectUrl)
    },
  },
}
